import React from "react";

/**
 * Reusable PopularItems component
 * Displays a grid of popular items with rankings and progress bars
 * @param {Object} props - Component props
 * @param {string} props.title - Title for the section
 * @param {Array} props.items - Array of items with name and sales properties
 * @param {string} props.itemLabel - Label for the item type (e.g., "orders", "sales")
 * @param {string} props.className - Additional CSS classes
 */
const PopularItems = ({
  title = "Popular Items",
  items = [],
  itemLabel = "orders",
  emptyMessage = "No data available",
  className = "",
}) => {
  const maxSales =
    items.length > 0 ? Math.max(...items.map((item) => item.sales)) : 0;

  return (
    <section
      className={`border-border bg-card text-card-foreground rounded-lg border p-6 shadow-sm ${className}`}
    >
      <h2 className="mb-6 text-lg font-semibold">{title}</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {items.map((item, index) => (
          <div
            key={item.id || item.category_id || item.name}
            className="bg-muted rounded-md p-4"
          >
            <div className="mb-2 flex items-center justify-between">
              <span
                className="text-foreground truncate font-medium"
                title={item.name}
              >
                {item.name}
              </span>
              <span className="text-muted-foreground ms-2 flex-shrink-0 text-xs tabular-nums">
                #{index + 1}
              </span>
            </div>
            <div className="text-muted-foreground text-sm tabular-nums">
              {item.sales} {itemLabel}
            </div>
            <div className="bg-background mt-2 h-2 rounded-full">
              <div
                className="bg-primary h-2 rounded-full transition-[width] duration-300 motion-reduce:transition-none"
                style={{
                  width: `${maxSales > 0 ? (item.sales / maxSales) * 100 : 0}%`,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      {items.length === 0 && (
        <div className="py-8 text-center" role="status">
          <div className="text-muted-foreground text-sm">{emptyMessage}</div>
        </div>
      )}
    </section>
  );
};

export default PopularItems;
